import { formattedDate } from '@components/mewoz/Tasks/TaskAction/TaskMessageHeader';
import { Case, Profile } from '@graphql/generated';
import { formatNumber } from '@logic/formatNumber';
import { ACTIVE_YEAR } from '../constants';

const salutations: Record<string, string> = {
  mr: 'meneer',
  ms: 'mevrouw',
};

export const parseHtml = (children: string, propertyData?: Case, deadline?: string | null, createdAt?: string | null, userData?: Profile ): string | null => {
  if (!children) {
    return null
  }

  const activeYear = propertyData?.taxYear || ACTIVE_YEAR
  const woz = propertyData?.wozData?.objectionWoz || 0
  const woz_final = propertyData?.wozData?.finalWoz || 0
  const finalSavings = propertyData?.wozData?.finalSavings
  const finalSavingsText = finalSavings
    ? `€ ${formatNumber(finalSavings?.min as number)} tot € ${formatNumber(finalSavings?.max as number)}`
    : ''
  const woz_diff = Math.abs(woz_final - woz)
  const date = deadline ? formattedDate(deadline) : ''
  const advisor = `${propertyData?.assignedValuator?.firstName || ''} ${propertyData?.assignedValuator?.surname || ''}` 
  const salutation = salutations[userData?.salutation || ''] || '';
  const surname = userData?.surname || '';
  const created_at = createdAt ? formattedDate(createdAt) : ''
  
  return children
    .replaceAll(/<(\/)?div(.*?)>/g, '<$1p$2>')
    .replaceAll(/\[municipality]/g, propertyData?.municipality || '')
    .replaceAll(/\[activeYear]/g, activeYear.toString())
    .replaceAll(/\[activeYear-1]/g, (activeYear - 1).toString())
    .replaceAll(/\[activeYear-2]/g, (activeYear - 2).toString())
    .replaceAll(/\[activeYear-3]/g, (activeYear - 3).toString())
    .replaceAll(/\[activeYear\+1]/g, (activeYear + 1).toString())
    .replaceAll(/\[activeYear\+2]/g, (activeYear + 2).toString())
    .replaceAll(/\[activeYear\+3]/g, (activeYear + 3).toString())
    .replaceAll(/\[activeYearMin3]/g, (activeYear - 3).toString())
    .replaceAll(/\[activeYearPlusOne]/g, (activeYear + 1).toString())
    .replaceAll(/\[woz_value]/g, formatNumber(woz))
    .replaceAll(/\[woz_diff]/g, formatNumber(woz_diff))
    .replaceAll(/\[woz_final]/g, formatNumber(woz_final))
    .replaceAll(/\[final_savings]/g, finalSavingsText)
    .replaceAll(/\[advisor]/g, advisor)
    .replaceAll(/\[date]/g, date)
    .replaceAll(/\[salutation]/g, salutation)
    .replaceAll(/\[surname]/g, surname)
    .replaceAll(/\[created_at]/g, created_at)
}

export const parseGenericShortcodes = (children: string): string | null => {
  if (!children) {
    return null
  }

  const activeYear = ACTIVE_YEAR

  return children
    .replaceAll(/\[activeYear]/g, activeYear.toString())
    .replaceAll(/\[activeYear-1]/g, (activeYear - 1).toString())
    .replaceAll(/\[activeYear-2]/g, (activeYear - 2).toString())
    .replaceAll(/\[activeYear-3]/g, (activeYear - 3).toString())
    .replaceAll(/\[activeYear\+1]/g, (activeYear + 1).toString())
    .replaceAll(/\[activeYear\+2]/g, (activeYear + 2).toString())
    .replaceAll(/\[activeYear\+3]/g, (activeYear + 3).toString())
    .replaceAll(/\[activeYearMin3]/g, (activeYear - 3).toString())
    .replaceAll(/\[activeYearPlusOne]/g, (activeYear + 1).toString())
}

export const parseWozCheckShortcodes = (object: any) => {
  for (const key in object) {
    if (object[key] === null) {
      object[key] = null
    } else if (typeof object[key] === 'object') {
      object[key] = parseWozCheckShortcodes(object[key])
    } else if (typeof object[key] === 'string') {
      object[key] = parseGenericShortcodes(object[key])
    } else {
      object[key] = object[key]
    }
  }
  return object
}
